import RealTimeActions from 'flux/actions/RealTimeActions';
import { Map, fromJS } from 'immutable';

/**
 * EventViewMixin
 *
 */
export default {
  init() {
    this._initState();

    if (this.initListeners) this.initListeners();
  },

  _initState() {
    this.setState(Map({}));
  },

  onPopulateCompleted(event) {
    // In support of https://github.com/SHOFLO/Issues/issues/5086 ...
    // This has the effect of hiding the event title when it's a template container event
    if (event.globalTemplateContainer) {
      event.title = '';
    }

    this.setStateAndTrigger(fromJS(event));

    if (this.setup) this.setup();
  },

  onPopulateFailed() {
    console.log('failed to load event');
  },

  /**
   * Handle incoming real time changes
   *
   */
  onEventMutatedRealTime(teamId, eventId, changes) {
    if (eventId !== this.getState().get('_id')) return;

    this.setStateAndTrigger(this.getState().merge(fromJS(changes)));
  },

  // eslint-disable-next-line no-unused-vars
  onEventDuplicationCompletedRealtime({ teamId, eventId }) {
    if (eventId !== this.getState().get('_id')) return;

    this.setInStateAndTrigger('isDuplicating', false);
  },

  onUpdateFieldCompleted(event) {
    this.setStateAndTrigger(fromJS(event));
  },

  /**
   * Update event when photo is uploaded
   */
  onUpdatePhotoCompleted(event) {
    this.mergeStateAndTrigger(fromJS(event));
  },

  onEventUpdatePhotoRealTime(teamId, eventId, event) {
    if (eventId !== this.getState().get('_id')) return;
    this.mergeStateAndTrigger(fromJS(event));
  },

  setup() {
    RealTimeActions.subscribeToEvent(this.getState());
  },
};
